// this component was originally meant to be reusable
// BUT it's actually kinda dogwater
// PLEASE DO NOT USE THIS COMPONENT
// YOU WILL REGRET IT
// If you realllly need to use this component, the media queries would need to be factored out
// and "children"s font size passed in as a prop to calculate the size of OtherLang / Angle
// who has time for that? not me
// that's also an annoying way to consume this component tbh cause you'd likely have to manage multiple custom breakpoints in the parent component every time you use this
// it's also trash when the text is too long, you'll have to manage that in the parent component too (see InteractiveSection.tsx)
// so you know what? don't use this component
// at least not right now
// I'm sorry
// -Mike (and copilot)

import styled from '@emotion/styled'
import { headerSlantLeft, headerSlantLeftBlue, headerSlantRight, headerSlantRightBlue, black } from '../styles'

export const DualLangHeaderWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, auto);
  align-content: center;
  grid-column-gap: 24px;
`

export const Angle = styled.img<{ right?: boolean }>`
  width: 40px;
  align-self: center;
  grid-column: ${({ right }) => right ? 3 : 1};
  grid-row: 1 / span 2;

  @media (max-width: 575px) { width: 30px; }
  @media (max-width: 400px) { width: 20px; }
`

export const OtherLang = styled.p`
  position: relative;
  color: ${black};
  font-family: 'Noto Sans JP Black';
  font-size: 1.5rem;
  align-self: end;
  top: 8px;

  // this isn't good for the reusability of this component but for now don't have time to make it better
  // ideally should be a percentage of the text size passed in as children -Mike
  @media (max-width: 575px) { font-size: 1.25rem; }
  @media (max-width: 400px) { font-size: 1rem; }
`

const DualLangHeader = ({ otherLang = '', children, blue = false, style = {}, className = '' }) => {
  return (
    <DualLangHeaderWrapper style={style} className={className}>
      <Angle src={blue ? headerSlantLeftBlue : headerSlantLeft} />
        <OtherLang>{otherLang}</OtherLang>
        {children}
      <Angle src={blue ? headerSlantRightBlue : headerSlantRight} right />
    </DualLangHeaderWrapper>
  )
}

export default DualLangHeader
